var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.value,"items-per-page":15,"custom-filter":_vm.$options.localeIncludes,"loading":_vm.loading,"loading-text":_vm.$t('general.loading')}})}
var staticRenderFns = []

export { render, staticRenderFns }